export { default } from './ZinioUnlimitedMagazines';
